import { get } from 'lodash';
import { connect } from 'react-redux';

import StoryCard, { ORIENTATION } from 'components/CustomCollectionStoryCard';
import { CAMPAIGN_NAMES, PERSONALIZATION_STATUS } from 'constants/personalizations';
import DYRecommendationsModel from 'models/DYRecommendations';
import StoryCardModel from 'models/StoryCard';
import * as actions from 'state/actions';
import { getStoryCardData } from 'state/selectors/collection';
import PersonalizationsSelector from 'state/selectors/personalizations';

export { ORIENTATION };

const mapStateToProps = (state, { storyId }) => {
  const storyData = getStoryCardData(state, storyId);
  const campaignData = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.COLLECTION_STORY_CARDS
  );
  let recommendationsData;

  if (campaignData?.status === PERSONALIZATION_STATUS.SUCCESS) {
    recommendationsData = new DYRecommendationsModel(campaignData);
  }

  const metadata = get(recommendationsData, ['_data', 'variations', 0, 'analyticsMetadata']);
  const dyCampaignData = {
    campaignId: metadata?.campaignId,
    campaignName: metadata?.campaignName,
    variationId: metadata?.variationId,
    variationName: metadata?.variationName,
    experienceId: metadata?.experienceId,
    experienceName: metadata?.experienceName,
  };

  if (!storyData) {
    throw new Error(`Could not find story with id "${storyId}"`);
  }

  const story = new StoryCardModel(storyData);

  return {
    paragraph: story.paragraph,
    backgroundColor: story.backgroundColor,
    dyCampaignData,
    headline: story.headline,
    header: story.header,
    textColor: story.textColor,
    backgroundImagePortrait: story.backgroundImagePortrait,
    backgroundImageLandscape: story.backgroundImageLandscape,
    icon: story.icon,
    ctaLinks: story.ctaLinks,
  };
};

const mapDispatchToProps = dispatch => ({
  trackCtaLinkClick: ({
    type,
    location,
    name,
    value,
    url,
    campaignName,
    variationId,
    variationName,
    experienceName,
  }) => {
    dispatch(
      actions.trackStoryCardCtaLinkClick({
        type,
        location,
        name,
        value,
        url,
        campaignName,
        variationId,
        variationName,
        experienceName,
      })
    );

    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryCard);
